import React, { useEffect, useState } from 'react'
import ErrorMessage from '../../../../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../../../../UI/form/MyButton'
import { checkValid, setValueForm, updateValidate } from '../../../../../../../../helpers/form/FormHelper'
import SupplyBillItems from './items/SupplyBillItems'
import SupplyBillItemTable from './items/SupplyBillItemTable'
import { responseError } from '../../../../../../../../helpers/response/ResponseHelper'
import { addSupplyBillAPI, editSupplyBillAPI, getSupplyBillsByOrderIdAPI } from '../../../../../../../../api/supply/supplyBillAPI'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../../../../helpers/form/FormData'
import SuppliersSearchSelectMain from '../../../../../../../form/fields/SuppliersSearchSelectMain'
import SupplyBillChooseTab from './items/fileds/SupplyBillChooseTab'
import SupplyBillsSearchSelectMain from '../../../../../../../form/fields/SupplyBillsSearchSelectMain'
import { useDispatch } from 'react-redux'
import { editSupplyOrderItems, setSupplyOrderBills } from '../../../../../../../../store/supplyOrderSlice'

const SupplyBillForm = ({ supplyOrderId, checked, setOpen, setChecked }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState({}) // Дані з форми

    // console.log('SupplyBillForm data', data)

    const [valid, setValid] = useState({}) // Валідація кожного поля
    // console.log('valid', valid)
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми

    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = setDataForBd()

        console.log('dataForBd', dataForBd)

        setError('')
        setLoading(true)

        // add(dataForBd)

        if (dataForBd.type === 'update') {
            edit(dataForBd)
        } else {
            add(dataForBd)
        }
    }

    const add = (dataForBd) => {
        addSupplyBillAPI(dataForBd).then(data => {
            if (data && data.supplyOrderNew.items) {
                dispatch(editSupplyOrderItems(data.supplyOrderNew.items))
            }
            if (data && data.supplyBills) {
                dispatch(setSupplyOrderBills(data.supplyBills))
            }
            if (setChecked) {
                setChecked({})
            }
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const edit = (dataForBd) => {
        editSupplyBillAPI(dataForBd).then(data => {
            if (data && data.supplyOrderNew.items) {
                dispatch(editSupplyOrderItems(data.supplyOrderNew.items))
            }
            if (data && data.supplyBills) {
                dispatch(setSupplyOrderBills(data.supplyBills))
            }
            // getSupplyBills() // Оновлюємо рахунки в заявці
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    // const getSupplyBills = () => {
    //     setLoading(true)
    //     setError('')
    //     getSupplyBillsByOrderIdAPI({ supplyOrderId }).then(data => {
    //         // setSupplyBills(data)
    //         dispatch(setSupplyOrderBills(data))
    //         setLoading(false)
    //     }).catch(e => {
    //         setError(responseError(e))
    //         setLoading(false)
    //     })
    // }

    const setDataForBd = () => {
        let dataForBd = {
            supplyOrderId,
            type: data.type,
            supplierId: data.supplierId,
            supplyBillId: data.supplyBillId,
            items: data.items,
        }

        // if (data.id) {
        //     dataForBd = {
        //         ...dataForBd,
        //         id: data.id
        //     }
        // }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Створення нового рахунку для обраних позицій або додавання позицій в існуючий рахунок
            </p>
        </div>

        <SupplyBillChooseTab 
            value={data && data.type ? data.type : ''}
            setValue={e => setValueForm(setData, 'type', e)}
        />

        {
			formDataProductIsField('supplier', 'supplyBill') ?
				<SuppliersSearchSelectMain
					required={
                        data && data.type && data.type === 'update' ? false :
                        formDataProductRequiredField('supplier', 'supplyBill')
                    }
					setValidate={e => updateValidate(setValid, 'supplierId', e)}
					setValueForm={e => setValueForm(setData, 'supplierId', e)}
					forciblyValue={data && data.supplierId ? data.supplierId : ''}
                    className={data && data.type && data.type === 'update' ? 'hide' : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('supplyBill', 'supplyBill') ?
				<SupplyBillsSearchSelectMain
					required={
                        data && data.type && data.type === 'add' ? false :
                        formDataProductRequiredField('supplyBill', 'supplyBill')
                    }
					setValidate={e => updateValidate(setValid, 'supplyBillId', e)}
					setValueForm={e => setValueForm(setData, 'supplyBillId', e)}
					forciblyValue={data && data.supplyBillId ? data.supplyBillId : ''}
                    className={data && data.type && data.type === 'add' ? 'hide' : ''}
                    status={'work'}
				/>
			: ''
        }

        <SupplyBillItemTable 
            // supplyOrderItems={supplyOrderItems}
            checked={checked}
            setValueForm={e => setValueForm(setData, 'items', e)}
            setValidate={e => updateValidate(setValid, 'items', e)}
            // setValueForm={e => setData(e)}
            // setValidate={e => setValid(e)}
        />

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default SupplyBillForm